import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { userLogOut } from "../../store/authSlice/auth-actions";

import classes from "./Dropdown.module.css";
import { BsPersonCircle } from "react-icons/bs";

const Dropdown = () => {
  const [menuState, setMenuState] = useState(false);
  const menuRef = useRef();
  const dispatch = useDispatch();
  const isloggedIn = useSelector((state) => state.auth.userLoggedIn);
  
  const menuToggleHandler = () => {
    setMenuState((prev) => !prev);
  };
  const menuCloseHandler = () => {
    setMenuState(false);
  };
  const logoutHandler = () => {
    dispatch(userLogOut());
    setMenuState(false);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        menuCloseHandler();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={menuRef}>
      {menuState && (
        <div className={classes.dropdown}>
          <ul className={classes.list}>
            {isloggedIn ? (
              <>
                <li>
                  <Link to="/profile">View profile</Link>
                </li>
                <li onClick={logoutHandler}>Logout</li>
              </>
            ) : (
              <li>
                <Link to="/login">Login</Link>
              </li>
            )}
          </ul>
        </div>
      )}
      <h2 className={classes[`nav-item`]}>
        <BsPersonCircle size={29} onClick={menuToggleHandler} />
      </h2>
    </div>
  );
};

export default Dropdown;
